import { Badge } from "@design";
import { useTranslation } from "react-i18next";
import type { FeedbackResponse } from "@/api";
import { categoryVariant, type FeedbackCategory, type FeedbackStatus, statusVariant } from "./feedbackLabels";

export function CategoryBadge({ category }: Readonly<{ category: string }>) {
  const { t } = useTranslation("adminFeedback");
  return (
    <Badge variant={categoryVariant(category)}>
      {t(`categories.${category as FeedbackCategory}`, { defaultValue: category })}
    </Badge>
  );
}

export function StatusBadge({ status }: Readonly<{ status: string }>) {
  const { t } = useTranslation("adminFeedback");
  return (
    <Badge variant={statusVariant(status)}>{t(`statuses.${status as FeedbackStatus}`, { defaultValue: status })}</Badge>
  );
}

export const submitterOf = (item: FeedbackResponse) => item.userName || item.userEmail || null;
